import React from 'react';
import fr from 'facet-rest';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { DialogActions, DialogContent } from 'Views/Page/Content/Modal/Components';
import {
  FDBodyText, FDClickableText,
  FDPrimaryActionButton, FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { ClickableTextRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/ClickableTextRel';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';

export default function RequestChurnWithConcessionsAdditionalFeedbackStepLayout() {
  const {
    resource, onSubmit, saving,
  } = useMetaLayoutContext();
  const { clearModalCollection } = useModalContext();

  return (
    <>
      <MetaControlField attr="title" />
      <DialogContent scrollKey={resource?.type() + resource?.id()}>
        <FDStack direction="column" spacing={2}>
          <MetaControlField attr="description" />
          <MetaControlField attr="quote" />
          <MetaControlField attr="additionalFeedback" rows={4} />
        </FDStack>
      </DialogContent>
      <DialogActions>
        <FDStack direction="column" spacing={2} flex={1}>
          {resource.meta().canPost() ? <FDPrimaryActionButton flex={1} loading={saving} label="Continue" onClick={onSubmit} /> : null}
          <FDBodyText
            align="start"
            color="textSecondary"
            value={
            resource.withRelationship(
              fr.relationships.chooseAnother.name,
              (rel) => (<ClickableTextRel relationship={rel} appearance="standalone" />),
              () => (<FDClickableText appearance="standalone" label="I don't want to cancel" onClick={clearModalCollection} />),
            )
          }
          />
        </FDStack>
      </DialogActions>
    </>
  );
}
